import React from "react";
import ReactMarkdown from "react-markdown";
import Bubble from "./Bubble";
import { makeStyles } from '@mui/styles';
const breaks = require("remark-breaks");

const useStyles = makeStyles({
  markdown: {
    "& p": {
      marginBottom: 0,
      fontSize: "inherit"
    }
  }
});

function Text({ children, ...props }) {
  const classes = useStyles();

  const LinkRenderer = ({ href, children }) => (
    <a href={href} rel="noopener noreferrer nofollow" target="_blank" aria-label={children}>
      {children}
    </a>
  );

  return (
    <Bubble {...props}>
      <ReactMarkdown
        className={classes.markdown}
        plugins={[breaks]}
        renderers={{ link: LinkRenderer }}
      >
        {children}
      </ReactMarkdown>
    </Bubble>
  );
}

export default Text;
